<div id="divChart" class="divChart">
    <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
        [legend]="barChartLegend" [chartType]="barChartType" label="heures"> </canvas>
</div>